import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Card, CardContent, Typography, TextField, FormControl, InputLabel, Select, MenuItem, Paper, Chip, Button } from "@mui/material";
import AdminLayout from "../AdminLayout";
import eventV2 from "../../services/eventV2Service";
import { useAuth } from "../../hooks/useAuth";

export default function AdminEventsV2List() {
  const { userProfile } = useAuth();
  const navigate = useNavigate();
  const [events, setEvents] = useState([]);
  const [search, setSearch] = useState("");
  const [typeFilter, setTypeFilter] = useState("all");

  useEffect(() => {
    const unsub = eventV2.listenEvents((list) => setEvents(list));
    return () => unsub();
  }, []);

  const filtered = useMemo(() => {
    const s = search.toLowerCase();
    return events.filter((e) => {
      const typeOk = typeFilter === "all" || e.type === typeFilter;
      const textOk = `${e.title||""} ${e.description||""} ${e.venue||""}`.toLowerCase().includes(s);
      return typeOk && textOk;
    });
  }, [events, search, typeFilter]);

  if (userProfile?.role !== "admin") {
    return (
      <AdminLayout title="Events">
        <Box sx={{ p: 3 }}>
          <Typography variant="h6">Unauthorized Access</Typography>
        </Box>
      </AdminLayout>
    );
  }

  return (
    <AdminLayout title="Events V2">
      <Box sx={{ p: 3 }}>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 2, gap: 2, flexWrap: "wrap" }}>
          <Typography variant="h6" sx={{ fontWeight: 800, color: "#003366" }}>Manage Events</Typography>
          <Box sx={{ display: "flex", gap: 1 }}>
            <TextField size="small" placeholder="Search" value={search} onChange={(e) => setSearch(e.target.value)} />
            <FormControl size="small" sx={{ minWidth: 120 }}>
              <InputLabel>Type</InputLabel>
              <Select value={typeFilter} label="Type" onChange={(e) => setTypeFilter(e.target.value)}>
                <MenuItem value="all">All</MenuItem>
                <MenuItem value="internal">Internal</MenuItem>
                <MenuItem value="external">External</MenuItem>
              </Select>
            </FormControl>
            <Button variant="contained" onClick={() => navigate("/admin/events-v2/create")}>Create Event</Button>
          </Box>
        </Box>

        {filtered.length === 0 ? (
          <Typography color="text.secondary">No events yet</Typography>
        ) : (
          <Box sx={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(280px,1fr))", gap: 2 }}>
            {filtered.map(evt => (
              <Paper key={evt.id} sx={{ p: 2, border: "1px solid #e5e7eb", borderRadius: 2, cursor: "pointer" }} onClick={() => navigate(`/admin/events-v2/${evt.id}`)}>
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1 }}>
                  <Box>
                    <Typography sx={{ fontWeight: 700 }}>{evt.title || "Untitled Event"}</Typography>
                    <Typography variant="body2" color="text.secondary">
                      {(evt.type ? String(evt.type).toUpperCase() : "UNKNOWN")} • {evt.date || "TBD"} • {evt.venue || "Venue TBA"}
                    </Typography>
                  </Box>
                  <Chip label={`Credit Cap: ${evt.credit_cap || 0}`} size="small" />
                </Box>
                <Typography variant="body2" color="text.secondary" sx={{ minHeight: 40 }}>
                  {evt.description || "No description"}
                </Typography>
              </Paper>
            ))}
          </Box>
        )}
      </Box>
    </AdminLayout>
  );
}
